import React from 'react'

type Props = {
  title?: string
  metaDescription?: string
  keywords?: string
  ogUrl?: string
  ogTitle?: string
  ogDescription?: string
  ogImage?: string
  noIndex?: boolean
  children?: React.ReactNode // headタグに追加したいものがある場合に使用
}

export const DEFAULT_TITLE = '効果的な販促・集客 法人向けデジタルギフト'
const DEFAULT_DESCRIPTION =
  'giftee for Businessとは、スタバやコンビニなど有名ブランドの商品をノベルティとして活用できる、今話題のキャンペーンツールです。選べる商品は1000種類以上、価格帯も100円から幅広く取り揃えており、デジタルギフトで顧客満足度の高いマーケティング、プロモーション施策を実現します。'
const DEFAULT_KEYWORDS = 'デジタルギフト, キャンペーン, giftee'
const DEFAULT_URL = 'https://giftee.biz'
const DEFAULT_OG_IMAGE = 'https://giftee.biz/assets/images/ogps/default.png'

export const Seo: React.FC<Props> = ({
  title = DEFAULT_TITLE,
  metaDescription = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  ogUrl = DEFAULT_URL,
  ogTitle = DEFAULT_TITLE,
  ogDescription = DEFAULT_DESCRIPTION,
  ogImage = DEFAULT_OG_IMAGE,
  noIndex = false,
  children,
}) => (
  <>
    <title>{title}</title>
    <meta name="description" content={metaDescription} />
    <meta name="keywords" content={keywords} />
    <meta property="og:url" content={ogUrl} />
    <meta property="og:title" content={ogTitle} />
    <meta property="og:description" content={ogDescription} />
    <meta property="og:image" content={ogImage} />
    {noIndex && <meta name="robots" content="noindex" />}
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="giftee for Business" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@_giftee" />
    <link
      rel="shortcut icon"
      type="image/x-icon"
      href="/assets/images/favicon.ico"
    />
    <link
      rel="apple-touch-icon"
      type="image/png"
      sizes="180x180"
      href="/assets/images/apple-touch-icon.png"
    />
    {children}
  </>
)
